import { FranchisePagePageData } from '../franchise-page';
import { FranchiseServicePageData } from '../franchise-service';

function commercialResidentialText(args: FranchisePagePageData, focusedType: keyof FranchisePagePageData): string;
function commercialResidentialText(args: FranchiseServicePageData, focusedType: keyof FranchiseServicePageData): string;
function commercialResidentialText(
    data: Partial<FranchisePagePageData & FranchiseServicePageData>,
    focusedType: keyof FranchisePagePageData | keyof FranchiseServicePageData,
): string {
    const prefixes = {
        Residential: false,
        Commercial: false,
    };

    if (!data || !focusedType || !(focusedType in data)) return Object.entries(prefixes).filter(x => x[1]).map(x => x[0]).join(' & ');

    const theData = data[focusedType];

    if (theData && 'linkedServiceType' in theData && theData.linkedServiceType) {
        const prefixKeys = Object.keys(prefixes);

        const relevantServices = (data?.franchise?.servicesProvidedFilterable || []).map(x => x?.serviceLine).reduce<string[]>((acc, val) => {
            if (val) {
                return [...acc, ...val.split(',')];
            }
            return acc;
        }, []);
        const servicesForPage = (theData?.linkedServiceType?.franchiseServiceMapping || '').split(',').flatMap((x: string) => {
            if (!prefixKeys.find(y => y.startsWith(x))) {
                return prefixKeys.map(key => `${key} ${x}`);
            }
            return [x];
        });

        const onPageRelevantServicesWithPrefix = relevantServices.filter(x => servicesForPage.includes(x));

        onPageRelevantServicesWithPrefix.forEach((serviceLine) => {
            const foundKey = prefixKeys.find(x => serviceLine.startsWith(x));
            if (foundKey) {
                prefixes[foundKey as keyof typeof prefixes] = true;
            }
        });
    }

    return Object.entries(prefixes).filter(x => x[1]).map(x => x[0]).join(' & ');
}

export default commercialResidentialText;
